import { backendApi } from "@/services/backend/api";

const serviceKindMatchApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    showServiceKindMatch: build.query<Match, ShowRequest>({
      query: (request) => ({
        url: `/dynamics/service-kind-match`,
        method: "GET",
        params: request,
      }),
      providesTags: (result) =>
        result
          ? [
              { type: "ServiceKindMatch", id: result.serviceKind },
              "ServiceKindMatch",
            ]
          : [],
    }),
    putServiceKindMatch: build.mutation<Match, PutRequest>({
      query: (request) => ({
        url: `/dynamics/service-kind-match`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: (result, error, request) => [
        { type: "ServiceKindMatch", id: request.serviceKind },
        "ServiceKindMatch",
      ],
    }),
    deleteServiceKindMatch: build.mutation<Match, DeleteRequest>({
      query: (request) => ({
        url: `/dynamics/service-kind-match`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: (result, error, request) => [
        { type: "ServiceKindMatch", id: request.serviceKind },
        "ServiceKindMatch",
      ],
    }),
    listAxDienstleistung: build.query<
      AxDienstleistungList,
      ListAxDienstleistungRequest
    >({
      query: (request) => ({
        url: `/dynamics/service-kind-match/list-ax-dienstleistung`,
        method: "GET",
        params: request,
      }),
    }),
  }),
});

export const {
  useShowServiceKindMatchQuery,
  usePutServiceKindMatchMutation,
  useDeleteServiceKindMatchMutation,
  useListAxDienstleistungQuery,
} = serviceKindMatchApi;

export interface Match {
  serviceKind: string;
  axDienstleistungValue: number;
}

export interface ShowRequest {
  serviceKind: string;
}

export interface PutRequest {
  serviceKind: string;
  axDienstleistungValue: number;
}

export interface DeleteRequest {
  serviceKind: string;
}

export interface AxDienstleistungList {
  axDienstleistungen: AxDienstleistung[];
  count: number;
}

export interface AxDienstleistung {
  value: number;
  label: string;
}

export type ListAxDienstleistungRequest = object;
